import {apiConnector} from "./apiconnector";
const API_URL = process.env.REACT_APP_API_URL;

// Coaching Video APIs
export const getVideos = async (params = {}) => {
  try {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined) searchParams.append(key, params[key]);
    });
    
    const response = await apiConnector('GET', `${API_URL}/coaching/videos?${searchParams}`);
    return response;
  } catch (error) {
    console.error('Error fetching videos:', error);
    throw error;
  }
};

export const createVideo = async (videoData) => {
  try {
    const response = await apiConnector('POST', `${API_URL}/coaching/videos`, videoData);
    return response;
  } catch (error) {
    console.error('Error creating video:', error);
    throw error;
  }
};

export const updateVideo = async (id, videoData) => {
  try {
    const response = await apiConnector('PUT', `${API_URL}/coaching/videos/${id}`, videoData);
    return response;
  } catch (error) {
    console.error('Error updating video:', error);
    throw error;
  }
};

export const deleteVideo = async (id) => {
  try {
    const response = await apiConnector('DELETE', `${API_URL}/coaching/videos/${id}`);
    return response;
  } catch (error) {
    console.error('Error deleting video:', error);
    throw error;
  }
};

export const assignVideoToUser = async (videoId, employeeId, assignmentData = {}) => {
  try {
    const response = await apiConnector('POST', `${API_URL}/coaching/videos/${videoId}/assign`, {
      employeeId,
      ...assignmentData
    });
    return response;
  } catch (error) {
    console.error('Error assigning video:', error);
    throw error;
  }
};

export const getVideoAssignments = async (videoId) => {
  try {
    const response = await apiConnector('GET', `${API_URL}/coaching/videos/${videoId}/assignments`);
    return response;
  } catch (error) {
    console.error('Error fetching video assignments:', error);
    throw error;
  }
};

// User Coaching APIs
export const getMyCoaching = async (status = '') => {
  try {
    const params = status ? `?status=${status}` : '';
    const response = await apiConnector('GET', `${API_URL}/coaching/my-coaching${params}`);
    return response;
  } catch (error) {
    console.error('Error fetching my coaching:', error);
    throw error;
  }
};

export const updateCoachingProgress = async (assignmentId, progressData) => {
  try {
    const response = await apiConnector('PUT', `${API_URL}/coaching/assignments/${assignmentId}/progress`, progressData);
    return response;
  } catch (error) {
    console.error('Error updating coaching progress:', error);
    throw error;
  }
};

export const markCoachingCompleted = async (assignmentId, completionData = {}) => {
  try {
    const response = await apiConnector('PUT', `${API_URL}/coaching/assignments/${assignmentId}/complete`, completionData);
    return response;
  } catch (error) {
    console.error('Error marking coaching as completed:', error);
    throw error;
  }
};

// Analytics APIs
export const getCoachingAnalytics = async () => {
  try {
    const response = await apiConnector('GET', `${API_URL}/coaching/analytics`);
    return response;
  } catch (error) {
    console.error('Error fetching coaching analytics:', error);
    throw error;
  }
};